
import React, { useEffect } from "react";
import { IUiSchemaElemArgs } from "./SchemaController";

import { useCallback } from 'react';
import ReactFlow, { MiniMap, Controls, Background, useNodesState, useEdgesState, addEdge, Node } from 'reactflow';

import 'reactflow/dist/style.css';


import { registerComponentHandler } from "./SchemaExtensions";

/*
const initialNodes = [
    { id: '1', position: { x: 0, y: 0 }, data: { label: '1' } },
    { id: '2', position: { x: 0, y: 100 }, data: { label: '2' } },
];


const initialEdges = [{ id: 'e1-2', source: '1', target: '2' }];
*/


const FlowEditExtension = (props: { args: IUiSchemaElemArgs }) => {

//    const { args } = props;
    const args = props.args;
    const value = args.value as any;
    const [nodes, setNodes, onNodesChange] = useNodesState([]);
    const [edges, setEdges, onEdgesChange] = useEdgesState([]);

    useEffect(() => { 

        try {

            const processedNodes: Node[] = [];

            for (const node of value.nodes) {
                const newNode = { ...node };
                if (typeof newNode.data?.label === "string") {
                    newNode.data = {...newNode.data};
                    newNode.data.label = args.stringToComponent(newNode.data.label);
                }
                processedNodes.push(newNode);
            }

            setNodes(processedNodes);
            setEdges(value.edges);




        } catch (e) {
            console.log(e.message);
        }
    }, [value.nodes, value.edges]);


    const onConnect = useCallback((params) => setEdges((eds) => addEdge(params, eds)), [setEdges]);

    return (
        <ReactFlow
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onConnect={onConnect}
            proOptions={{ hideAttribution: true }}
        >
            <MiniMap />
            <Controls />
            <Background />
        </ReactFlow>
    );
};



registerComponentHandler("flow-edit", (args: IUiSchemaElemArgs) => <FlowEditExtension key={args.fullkey} args={args}/>);
